import { FieldAdapter } from '@mews/framework';
import { BreakpointRangeWithFallback, StructuredDate, TextInputProps, WithFocusTrapProps } from '@optimus-web/core';
import { DateRange } from '../../types';

export enum DatePeriod {
    Today = 'Today',
    Yesterday = 'Yesterday',
    Tomorrow = 'Tomorrow',
    ThisWeek = 'ThisWeek',
    LastWeek = 'LastWeek',
    NextWeek = 'NextWeek',
    ThisMonth = 'ThisMonth',
    LastMonth = 'LastMonth',
    NextMonth = 'NextMonth',
    ThisQuarter = 'ThisQuarter',
    LastQuarter = 'LastQuarter',
    NextQuarter = 'NextQuarter',
    ThisYear = 'ThisYear',
    LastYear = 'LastYear',
    NextYear = 'NextYear',
    Custom = 'Custom',
}

export enum DatePeriodType {
    Custom = 'Custom',
    This = 'This',
    Last = 'Last',
    Next = 'Next',
}

export enum DateUnit {
    Day = 'Day',
    Week = 'Week',
    Month = 'Month',
    Quarter = 'Quarter',
    Year = 'Year',
}

export interface DateRangePickerDropdownProps extends WithFocusTrapProps {
    allowOneDateRange?: boolean;
    breakpointRange: BreakpointRangeWithFallback;
    dateRange: DateRange;
    onChange: (dateRange: DateRange) => void;
    mode?: 'utc' | 'iso';
}

export interface DateRangePickerSelectFieldProps extends WithFocusTrapProps, TextInputProps {
    allowOneDateRange?: boolean;
    breakpointRange: BreakpointRangeWithFallback;
    handleChange?: () => void;
    mode?: 'utc' | 'iso';
}

export interface CustomDateRange {
    startDate?: StructuredDate;
    endDate?: StructuredDate;
}

export interface GetDefaultInputValueProps {
    dateRange: DateRange;
    mode: 'iso' | 'utc';
    transform: FieldAdapter;
}
